/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */

import {
  Dialog,
  DialogContent,
  Typography,
  Grid,
  IconButton,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {Image} from '@jobseeker/lotus';
import {ImgNextGen, trimText} from './homeCategory';
import {createUrl} from './utils';
import {s3Url} from './env';

export const SubCatPopUp = ({
  onCloseSubcategoryPopup,
  subcategories,
  category,
  companies,
  prefText,
  handleLogoClick,
  open,
}: any) => {
  return (
    <Dialog
      open={open}
      onClose={onCloseSubcategoryPopup}
      fullScreen
      sx={{
        width: '100%',
        top: 0,

        '& .MuiDialog-paper': {
          maxWidth: '1440px',
          //   maxHeight:"70%",
          boxShadow: '0 6px 24px rgba(0, 0, 0, 0.16)',
          backgroundColor: 'white',
          padding: 0,
          margin: 0,
          top: 0,
        },
      }}
    >
      {/* Close Button */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '10px',
        }}
      >
        <Typography
          component="a"
          href={`${createUrl(category.name, category.id, 'c')}?ref=homepagecat${
            prefText ? `&pref=${prefText}` : ''
          }`}
          sx={{
            fontSize: '16px',
            fontWeight: 'bold',
            marginLeft: '16px',
            cursor: 'pointer',
            textDecoration: 'none',
            color: 'black',
          }}
        >
          {category.name}
        </Typography>
        <IconButton
          onClick={onCloseSubcategoryPopup}
          sx={{color: 'rgba(0, 0, 0, 0.3)'}}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      <DialogContent sx={{overflowY: 'none'}}>
        {/* Category Heading */}

        {/* Subcategory Grid */}
        <Grid container spacing={2} sx={{padding: '20px 0px', paddingTop: 0}}>
          {subcategories.slice(0, 8).map((tag: any) => (
            <Grid item xs={6} sm={6} md={4} key={tag.id}>
              <a
                href={`${createUrl(tag.name, tag.id, 'k')}?ref=homepagetag${
                  prefText ? `&pref=${prefText}` : ''
                }`}
                style={{
                  textDecoration: 'none',
                  position: 'relative',
                  display: 'block',
                }}
              >
                <ImgNextGen
                  srcWebp={`${s3Url}/webp/V2${trimText(tag.name)}.webp`}
                  fallback={`${s3Url}/V2${trimText(tag.name)}.png`}
                  alt={tag.name}
                  height="100%"
                  width="100%"
                />
              </a>
            </Grid>
          ))}
        </Grid>

        {/* Popular Companies */}
        {companies.length > 0 && (
          <>
            <Typography
              sx={{
                fontSize: '16px',
                fontWeight: 'bold',
                marginLeft: '0px',
                marginTop: '20px',
              }}
            >
              Popular Companies
            </Typography>

            <Grid container spacing={2} sx={{padding: '20px 8px'}}>
              {companies.slice(0, 6).map((company: any) => (
                <Grid item xs={6} sm={6} md={4} key={company.companyId}>
                  <a
                    onClick={() =>
                      handleLogoClick(
                        company.link,
                        company.title,
                        company.companyId
                      )
                    }
                    style={{
                      textDecoration: 'none',
                      cursor: 'pointer',
                      display: 'block',
                      textAlign: 'center',
                    }}
                  >
                    <Image
                      src={company.companyLogo}
                      alt={company.title}
                      style={{width: '100%', display: 'block', margin: 'auto'}}
                    />
                  </a>
                </Grid>
              ))}
            </Grid>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
